'use es6';

import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import { SCHEDULE_FREQUENCY } from '../../../lib/schedulingLogic';
import { useControlsContext } from '../context';
import { getEventValue } from '../../../utils/jsEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const ShareDeliveryFrequencySelect = () => {
  const {
    shareScheduleFrequency,
    setShareScheduleFrequency,
    setShareScheduleOnDay
  } = useControlsContext();
  const schedulePickerOptions = [{
    value: SCHEDULE_FREQUENCY.DAILY,
    text: I18n.text('reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailScheduleOptionDaily')
  }, {
    value: SCHEDULE_FREQUENCY.WEEKLY,
    text: I18n.text('reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailScheduleOptionWeekly')
  }, {
    value: SCHEDULE_FREQUENCY.MONTHLY,
    text: I18n.text('reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailScheduleOptionMonthly')
  }];
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailScheduleFrequencyLabel"
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      className: "m-right-2",
      options: schedulePickerOptions,
      onChange: e => {
        setShareScheduleFrequency(getEventValue(e));
        // Explanation: It needs to reset and render appropriately depending on the frequencies (daily, weekly, monthly)
        setShareScheduleOnDay([]);
      },
      value: shareScheduleFrequency
    })
  });
};
export default ShareDeliveryFrequencySelect;